import axios_api, { get, post, put, del } from '@utils/axios_api';

/**
 * 일정관리(Plan) API 모음
 * - 백엔드 엔드포인트는 프로젝트에 맞게 조정하세요.
 * - 기본 baseURL: `${REACT_APP_BOOT_URL}/api`
 */
export const planApi = {
  // ================= 대시보드 =================
  getDashboardSummary: () => get('/plan/dashboard/summary'),
  // ================= 배정관리 =================
  listAssignments: (params) => get('/plan/assignments', { params }),
  
  // 🌟 (추가) 배정 정보 신규등록/전체수정
  upsertAssignment: (payload) => post('/plan/assignments', payload),

  // 🌟 (추가) 사업장 목록 조회
  listBizForSelect: () => get('/plan/assignments/biz-list'),

  // 배정 기준년도 목록 조회 (중복 제거)
  listAssignYears: () => get('/plan/assignments/years'),

  deleteAssignments: (ids) => post('/plan/assignments/delete', { ids }),

  // 🌟 (추가) 사업장 전체 담당자 1 변경
  patchCompanyStaff1: (bizMgtNo, staffId1) => axios_api.patch(`/plan/assignments/company/${bizMgtNo}/staff1`, { staffId1 }).then(r => r.data),

  // PATCH 개별 변경분 저장 (Backend PatchMapping 사용)
  patchAssignmentAssignees: (assignNo, payload) =>
    axios_api.patch(`/plan/assignments/${assignNo}/assignees`, payload).then(r => r.data),

  // PATCH 일괄 변경 (Backend PatchMapping 사용)
  bulkPatchAssignmentAssignees: (payload) =>
    axios_api.patch('/plan/assignments/assignees/bulk', payload).then(r => r.data),

  // 엑셀 업로드
  uploadAssignmentExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return post('/plan/assignments/excel-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // 🌟 (추가) 배정 목록 엑셀 다운로드 (현재 필터 조건 반영)
  downloadAssignmentsExcel: (params) => get('/plan/assignments/excel-download', { params, responseType: 'blob' }),

  // 엑셀 템플릿 다운로드
  downloadAssignmentExcelTemplate: () => get('/plan/assignments/excel-template', { responseType: 'blob' }),

  // ================= 담당자 검색 =================
  searchStaff: (params) => get('/plan/staff/search', { params }),

  // ================= 방문관리 =================
  listVisits: (params) => get('/plan/visits', { params }),
  upsertVisit: (payload) => post('/plan/visits', payload),
  // 🌟 (추가) 방문 일정/회차/상태 인라인 수정
  patchVisit: (assignNo, payload) => put(`/plan/visits/${assignNo}`, payload),
  // 🌟 토글 API 추가
  toggleVisitStatus: (assignNo) => axios_api.patch(`/plan/visits/${assignNo}/toggle-status`).then(r => r.data),

  // ================= 산출물관리 =================
  listDeliverableGroups: (params) => get('/plan/deliverables/groups', { params }),
  listDeliverableDetails: (bizMgtNo, staffId1) => get('/plan/deliverables/details', { params: { bizMgtNo, staffId1 } }),
  uploadDeliverableFile: (assignNo, files) => {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      return post(`/plan/deliverables/${assignNo}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteAllDeliverableFiles: (assignNo, atchFileId) => del(`/plan/deliverables/${assignNo}/file/${atchFileId}`),
  deleteSingleDeliverableFile: (assignNo, atchFileId, fileSn) => del(`/plan/deliverables/${assignNo}/file/${atchFileId}/${fileSn}`),

  downloadDeliverableFile: (atchFileId) => {
      return get('/plan/deliverables/download', {
          params: { atchFileId },
          responseType: 'blob' // 🌟 파일 다운로드를 위한 필수 설정
      });
  },

  // 🌟 (추가) 개별 파일 다운로드용 API 호출
  downloadSingleDeliverableFile: (atchFileId, fileSn) => {
      return get('/plan/deliverables/download-single', {
          params: { atchFileId, fileSn },
          responseType: 'blob' 
      });
  },

  downloadAllDeliverables: (params) => {
      return get('/plan/deliverables/download-all', {
          params, // 현재 적용된 검색 필터(회사명, 담당자 등)를 그대로 넘김
          responseType: 'blob' 
      });
  },

  // ================= 진행/Alert =================
  listProgress: (params) => get('/plan/progress', { params }),
  listAlerts: (params) => get('/plan/alerts', { params }),

  // ================= 사업장 마스터(Biz) 관리 =================
  listBiz: (params) => get('/plan/biz', { params }),
  createBiz: (data) => post('/plan/biz', data),
  updateBiz: (payload) => put('/plan/biz', payload), 
  deleteBizList: (ids) => post('/plan/biz/delete', { ids }),
  
  uploadBizExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return post('/plan/biz/excel-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // ================= 자료실(Reference) 관리 =================
  // 분류
  getRefCategories: () => get('/plan/references/categories'),
  addRefCategory: (catName) => post('/plan/references/categories', null, { params: { catName } }),
  deleteRefCategory: (catId) => del(`/plan/references/categories/${catId}`),

  // 게시글
  listRefPosts: (catId, page = 0, size = 10) => get('/plan/references', { params: { catId, page, size } }),
  getRefPost: (refId) => get(`/plan/references/${refId}`),
  createRefPost: (formData) => post('/plan/references', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateRefPost: (refId, formData) => put(`/plan/references/${refId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteRefPost: (refId) => del(`/plan/references/${refId}`),
  deleteRefFile: (refId, fileSn) => del(`/plan/references/${refId}/files/${fileSn}`),
  downloadRefFile: (atchFileId, fileSn) => get('/plan/references/files/download', {
      params: { atchFileId, fileSn },
      responseType: 'blob'
  }),

  // ================= 내 정보 (Profile/Account) =================
  getMyInfo: () => get('/plan/member/me'),
  updateMyInfo: (payload) => put('/plan/member/me', payload),
  changePassword: (payload) => put('/plan/member/me/password', payload),
  getLoginHistory: () => get('/plan/member/me/history'),
  deactivateAccount: () => post('/plan/member/me/deactivate'),

  // ================= 관리자용 회원(Member) 관리 =================
  // 회원 목록 조회
  listMembers: (params) => get('/plan/members', { params }),
  // 신규 회원 등록
  createMember: (payload) => post('/plan/members', payload),
  // 회원 정보 수정
  updateMember: (memberId, payload) => put(`/plan/members/${memberId}`, payload),
  // 회원 삭제 (상태 변경)
  deleteMember: (memberId) => del(`/plan/members/${memberId}`),
  // 수행요원 목록 전체 조회
  getAllStaffForMember: () => get('/plan/members/staff'),
  // 🌟 (추가) 회원 엑셀 업로드
  uploadMemberExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return post('/plan/members/excel-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // 🌟 (추가) 회원 엑셀 템플릿 다운로드
  downloadMemberExcelTemplate: () => get('/plan/members/excel-template', { responseType: 'blob' }),

  // ================= 수행요원(Staff) 관리 =================
  listStaffs: (params) => get('/plan/staff', { params }),
  createStaff: (payload) => post('/plan/staff', payload),
  updateStaff: (staffId, payload) => put(`/plan/staff/${staffId}`, payload),
  // 논리적 삭제(useYn = 'N')를 위해 delete API가 아닌 status patch 혹은 기존 delete API 재사용
  deleteStaff: (staffId) => del(`/plan/staff/${staffId}`),
  uploadStaffExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return post('/plan/staff/excel-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  downloadStaffExcelTemplate: () => get('/plan/staff/excel-template', { responseType: 'blob' }),
  getStaffDetail: (staffId) => get(`/plan/staff/${staffId}/detail`),
  saveStaffMajors: (staffId, list) => put(`/plan/staff/${staffId}/majors`, list),
  saveStaffCareers: (staffId, list) => put(`/plan/staff/${staffId}/careers`, list),
  saveStaffQualifications: (staffId, list) => put(`/plan/staff/${staffId}/qualifications`, list),

  // ================= 교육 관리 =================
  listTrainingCourses: (params) => get('/plan/training/courses', { params }),
  createTrainingCourse: (payload) => post('/plan/training/courses', payload),
  updateTrainingCourse: (courseId, payload) => put(`/plan/training/courses/${courseId}`, payload),
  toggleTrainingCourseUseYn: (courseId) => put(`/plan/training/courses/${courseId}/toggle-use`),

  listTrainingRecords: (params) => get('/plan/training/records', { params }),
  createTrainingRecord: (payload) => post('/plan/training/records', payload),
  updateTrainingRecord: (trainingId, payload) => put(`/plan/training/records/${trainingId}`, payload),
  deleteTrainingRecord: (trainingId) => del(`/plan/training/records/${trainingId}`),
  listTrainingRecordsByStaff: (staffId) => get(`/plan/training/records/staff/${staffId}`),

  // 🌟 (수정) 괄호 안에 넣기
  uploadHelpImage: (file, tokenId) => {
      const formData = new FormData();
      formData.append('file', file);
      if (tokenId) formData.append('tokenId', tokenId);
      return post('/plan/help/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
  },
  saveHelp: (payload) => post('/plan/help', payload),
  getHelp: (helpId) => get(`/plan/help/${helpId}`), // 🌟 (추가) 조회 API도 추가!

  listProgressSummary: (params) => get('/plan/progress/summary', { params }),
  listProgressDetails: (bizMgtNo, staffId) => get('/plan/progress/details', { params: { bizMgtNo, staffId } }),

  getNotifications: () => get('/plan/notifications'),
  getUnreadCount: () => get('/plan/notifications/unread-count'),
  getUnreadCountByType: () => get('/plan/notifications/unread-count-by-type'),
  markAllRead: () => axios_api.patch('/plan/notifications/read-all').then(r => r.data),
  markOneRead: (notiId) => axios_api.patch(`/plan/notifications/${notiId}/read`).then(r => r.data),
  deleteNotification: (notiId) => del(`/plan/notifications/${notiId}`),
};

export default planApi;